// extracted by mini-css-extract-plugin
export var label = "_d7-2";
export var slideContainer = "_d7-0";
export var slider = "_d7-1";